<template>
  <div>
    <iframe
      scrolling="no"
      :width="styl.width"
      :height="styl.pheight"
      frameBorder="0"
      allowTransparency="true"
      :src="setSrc"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    setSrc() {
      var _url =
        "https://open.weixin.qq.com/connect/qrconnect?appid=" +
        this.appid +
        "&scope=snsapi_login" +
        "&redirect_uri=" +
        this.redirect_uri +
        "&state=" +
        this.state +
        "&login_type=" +
        this.login_type +
        "&style=" +
        this.theme +
        "&self_redirect=" +
        this.self_redirect +
        "&href=" +
        this.href;
      console.log(_url)
      return _url;
    }
  },
  props: {
    styl: {
      type: Object,
      default: () => {
        return {
          width: 300,
          height: 400,
        }
      }
    },
    appid: {
      type: String,
      default: 'wx31aca2ee63d7fd34'
    },
    scope: {
      type: String,
      default: 'snsapi_login'
    },
    redirect_uri: {
      type: String,
      default: 'https://www.supertopit.com/abs/author/callBack.do'
    },
    state: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "black"
    },
    href: {
      type: String,
      default: ""
    },
    self_redirect: {
      type: Boolean,
      default: true
    },
    login_type: {
      type: String,
      default: "jssdk"
    }
  }
};
</script>